"use client";
import React, { useEffect } from "react";
import Section from "../../Components/Section/Section";
import FaqSection from "../../Components/NeedHelp/FaqSection";
import HelpSection from "../../Components/NeedHelp/HelpSection";
import ServiceRequestCount from "../../Components/ServiceRequestCount/Index";
import { _eventBus } from "../../core/events/EventBus";
import { evtTree } from "../../Orchestrator/ConstantTree";
import { useRecState } from "../../Orchestrator/Recoils/Events/Recoil";

const Help = () => {
  const [isAnonymous] = useRecState<boolean>("isAnonymousStateAtom");
  useEffect(() => {
    const evt = _eventBus.on<void, void>({
      eventName: evtTree.NeedHelp.FlowStarted,
      handler: async () => {        
        _eventBus.emit({
          eventName: evtTree.NeedHelp.Get.TicketList,
        });
      },
    });

    /**
     * This is because, to unregister @event evtTree.NeedHelp.FlowStarted
     * Once page is unmount.
     */
    return () => {
      evt.off();
    };
  }, []);
  return (
    <>
      <Section type="faq_section">
        <div className="container">
          <FaqSection />
        </div>
        <div className="container">
          <HelpSection />
        </div>
       {!isAnonymous && <div className="container">
          <ServiceRequestCount />
        </div>}
      </Section>
    </>
  );
};

export default Help;
